
import { ErrorSchema } from "@rjsf/core"
import { useEcoClient, useEcoMutation } from "hooks"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilState, useRecoilValue } from "recoil"
import { useQuizStore } from ".."
import {quizUser, isQuizSaved, isUserRegistered,quizLoaded} from "../states/quizState"
import {RegistrationType} from "./useRegistrationFormSchema"

export const useSaveResponeQuiz = (): useSaveResponeQuizType => {
    const navigate = useNavigate()
    const [defaultUser, setDefaultUser] = useRecoilState(quizUser)
    const [isRegistered, setIsRegistered] = useRecoilState(isUserRegistered)
    const [isSaved, setIsSaved] = useRecoilState(isQuizSaved)
    const [isLoading, setIsLoading] = useState(false)
    const currentQuiz = useRecoilValue(quizLoaded)
    const {getLastResponse, getResponses, getSteps, getQuizInfo} = useQuizStore()
    const ecoClient = useEcoClient();
    const [user, setUser] = useState<RegistrationType>()
    const [show, setShow] = useState(false)

    useEffect(() => {
        if((user && !isSaved) || show) {
            setIsLoading(true);
            saveQuiz.mutate(({
                templateId: currentQuiz.id || getQuizInfo()?.id, 
                questions: getSteps()?.split(';'),
                responses: getResponses()?.split(';'),
                quizUrl: `${process.env.REACT_APP_ECO_QUIZ_URL}/${currentQuiz.name || getQuizInfo()?.name}`
            }), {
                onSuccess: (res: any) => {
                    !isRegistered && setIsRegistered(true)
                    setIsSaved(true)
                    user && setDefaultUser(user)
                    show && setShow(false)
                    setIsLoading(false)
                    navigate(`/quiz/${currentQuiz.name || getQuizInfo()?.name}/${getLastResponse()}`)
                },
                onError: () => {
                    setIsLoading(false)
                }
            })
        }
    }, [user, show])

    const handleSubmit = (value?: Record<string, any>, e?: any, dirtiesFields?: Array<string>) => {
        if(dirtiesFields && dirtiesFields?.length > 0) {
            setUser(value)
            setIsSaved(false)
        }
            
    }

    const handleChange = (value?: Record<string, any>, e?: any, es?: ErrorSchema, dirtiesFields?: Array<string>) => {
            console.log(dirtiesFields)
    }

    const handleShowResult = () => {
        if(isRegistered) {
            setIsSaved(false)
            setShow(true)
        }
    }

    const saveQuiz = useEcoMutation(async (params: quizType) => {
        const tmpUser = !isRegistered ? user : {email: defaultUser?.email, userId: defaultUser?.userId }
        return ecoClient.post({
            path: `quiz.save`,
            data: {
                user: {...tmpUser},
                ...params
            },
            dataType: "json"
        });
    });

    return {
        isLoading,
        defaultUser,
        handleSubmit,
        handleChange,
        handleShowResult
    }
}

export type quizType = {
    templateId?: number
    questions?: Array<string>
    responses?: Array<string>
    extData?: string
    name?: string
    quizUrl?: string | null
    ke?: string
}

type useSaveResponeQuizType = {
    isLoading?: boolean
    defaultUser: RegistrationType,
    handleSubmit: (value?: Record<string, any>,
        e?: any,
        dirstiesFields?: Array<string>) => void,
    handleChange: (value?: any, e?: any, es?: ErrorSchema, dirtiesFields?: Array<string>) => void
    handleShowResult: () => void
}